import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';

export const VoucherScopeSchema = z.object({
  target_type: z.enum(['PRODUCT', 'MENTORING']),
  mode: z.enum(['ALL', 'WHITELIST']),
  product_ids: z.array(z.string()),
  mentors: z.array(
    z.object({
      mentor_id: z.string(),
      applies_to_all_topics: z.boolean(),
      topic_title_ids: z.array(z.number()),
    })
  ),
});
export type VoucherScopePayload = z.infer<typeof VoucherScopeSchema>;

export const CreateVoucherSchema = z.object({
  voucher_code: z
    .string()
    .min(1, {
      message: 'Kode voucher tidak boleh kosong!',
    })
    .max(10, {
      message: 'Kode voucher maksimal 10 karakter!',
    }),
  type: z.enum(['FLAT', 'PERCENTAGE'], {
    message: 'Tipe voucher tidak valid!',
  }),
  discount: z.number({ message: 'Diskon harus berupa angka!' }),
  stock: z.number({ message: 'Stok harus berupa angka!' }),
  expired_at: z.string().min(1, {
    message: 'Tanggal kadaluarsa tidak boleh kosong!',
  }),
  scopes: z.array(VoucherScopeSchema),
});
export type CreateVoucherPayload = z.infer<typeof CreateVoucherSchema>;
export type CreateVoucherResponse = ApiResponse<{
  name: string;
}>;

export const createVoucher = async (
  payload: CreateVoucherPayload
): Promise<CreateVoucherResponse> => {
  const url = 'voucher';

  return await apiClient.post(url, payload);
};

export function createVoucherMutationOptions() {
  return mutationOptions<
    CreateVoucherResponse,
    AxiosError,
    CreateVoucherPayload
  >({
    mutationFn: createVoucher,
  });
}
